import { DateTime } from 'luxon'
import axiosInstance from '../axiosInstance'
import { ShiftID } from '../shifts/models/shift'
import { SiteID } from '../sites/models/site'
import { EmployeeID } from '../employees/models/employee'
import { formatForServer } from '../common/utils/formatDate'

const ShiftCheckInEndpoints = {
    base: (siteId: SiteID) => `api/orgs/${siteId}` as const,
    checkIn: (siteId: SiteID, shiftId: ShiftID) => `${ShiftCheckInEndpoints.base(siteId)}/shifts/${shiftId}/check-in` as const,
    checkOut: (siteId: SiteID, shiftId: ShiftID) => `${ShiftCheckInEndpoints.base(siteId)}/shifts/${shiftId}/check-out` as const,
}

export interface ShiftCheckInForm {
    timestamp: DateTime | null

    latitude?: number | null
    longitude?: number | null

    comment?: string | null

    onBehalfOfEmployeeId?: EmployeeID | null
}

interface ShiftCheckInCreateData {
    timestamp?: string
    
    latitude?: number | null
    longitude?: number | null

    comment?: string | null

    on_behalf_of_employee_id?: string | null
}

export const checkIn = async (siteId: SiteID, shiftId: ShiftID, form: ShiftCheckInForm): Promise<void> => {
    const data: ShiftCheckInCreateData = {
        latitude: form.latitude,
        longitude: form.longitude,
        comment: form.comment,
        on_behalf_of_employee_id: form.onBehalfOfEmployeeId ?? undefined,
    }

    if (form.timestamp) {
        data.timestamp = formatForServer(form.timestamp)
    }

    await axiosInstance.put(ShiftCheckInEndpoints.checkIn(siteId, shiftId), data)
}

export const deleteCheckIn = async (siteId: SiteID, shiftId: ShiftID, onBehalfOfEmployeeId?: EmployeeID): Promise<void> => {
    const params = onBehalfOfEmployeeId ? { on_behalf_of_employee_id: onBehalfOfEmployeeId } : undefined

    await axiosInstance.delete(ShiftCheckInEndpoints.checkIn(siteId, shiftId), { params })
}

export const checkOut = async (siteId: SiteID, shiftId: ShiftID, form: ShiftCheckInForm): Promise<void> => {
    const data: ShiftCheckInCreateData = {
        latitude: form.latitude,
        longitude: form.longitude,
        comment: form.comment,
        on_behalf_of_employee_id: form.onBehalfOfEmployeeId ?? undefined,
    }

    if (form.timestamp) {
        data.timestamp = formatForServer(form.timestamp)
    }

    await axiosInstance.put(ShiftCheckInEndpoints.checkOut(siteId, shiftId), data)
}

export const deleteCheckOut = async (siteId: SiteID, shiftId: ShiftID, onBehalfOfEmployeeId?: EmployeeID): Promise<void> => {
    const params = onBehalfOfEmployeeId ? { on_behalf_of_employee_id: onBehalfOfEmployeeId } : undefined

    await axiosInstance.delete(ShiftCheckInEndpoints.checkOut(siteId, shiftId), { params })
}